import { createSelector } from 'reselect';

// Config
import { getIsExpressCheckoutSelector } from '@redux/reducers/app/appSelector';
import {
  getErrorItemIdSelector,
  getErrorMessageSelector,
  getEditBasketIsRemoveSelector,
} from '@redux/reducers/order-form/orderFormSelector';
import { getIsSignedInSelector } from '@redux/reducers/user/userSelector';
import { shouldShowCollectionHelpText } from '@utils/collection/collectionHelp';

export const makeGetShowCollectionHelp = () =>
  createSelector(
    [(state) => state, (_, props) => props.isChildItem, (_, props) => props.item],
    (state, isChildItem, item) => ({
      showCollectionHelp: shouldShowCollectionHelpText({
        isChildItem,
        id: item?.id,
        state,
      }),
    }),
  );

const editBasketItemState = createSelector(
  [
    getErrorItemIdSelector,
    getErrorMessageSelector,
    getIsExpressCheckoutSelector,
    getIsSignedInSelector,
    getEditBasketIsRemoveSelector,
  ],
  (errorItemId, errorMessage, isExpressCheckout, isSignedIn, editBasketIsRemove) => ({
    errorItemId,
    errorMessage,
    isExpressCheckout,
    isSignedIn,
    editBasketIsRemove,
  }),
);

export default editBasketItemState;
